interface MixThemePair {
  key: string
  value: string
}

export interface MixTheme {
  [index: number]: MixThemePair
}

export interface MixThemes {
  initial: MixTheme
  shape: MixTheme
  drive: MixTheme
  brain: MixTheme
}

export const mixThemes: MixThemes = {
  initial: [
    { key: "--mix-color1", value: "255, 240, 230" }, // Beige rosé
    { key: "--mix-color2", value: "245, 225, 210" }, // Beige doré
    { key: "--mix-color3", value: "235, 215, 200" }, // Beige orangé
    { key: "--mix-color4", value: "225, 205, 190" }, // Beige brun
    { key: "--mix-color5", value: "215, 195, 180" }, // Beige foncé
  ],
  shape: [
    { key: "--mix-color1", value: "255, 47, 146" }, // Rose vif
    { key: "--mix-color2", value: "240, 111, 56" }, // Orange vif
    { key: "--mix-color3", value: "245, 159, 0" }, // Jaune-Orange
    { key: "--mix-color4", value: "255, 47, 146" }, // Rose vif
    { key: "--mix-color5", value: "240, 111, 56" }, // Orange vif
  ],
  drive: [
    { key: "--mix-color1", value: "255, 100, 100" }, // Rouge clair
    { key: "--mix-color2", value: "230, 70, 120" }, // Rouge-Rose
    { key: "--mix-color3", value: "210, 60, 140" }, // Rouge pourpre
    { key: "--mix-color4", value: "190, 50, 160" }, // Rouge-violet
    { key: "--mix-color5", value: "170, 40, 180" }, // Violet
  ],
  brain: [
    { key: "--mix-color1", value: "200, 220, 255" }, // Bleu clair
    { key: "--mix-color2", value: "180, 200, 240" }, // Bleu moyen
    { key: "--mix-color3", value: "160, 180, 225" }, // Bleu foncé
    { key: "--mix-color4", value: "140, 160, 210" }, // Bleu profond
    { key: "--mix-color5", value: "120, 140, 195" }, // Bleu nuit
  ],
}
